<template>
    <header class="edit_parent_header edit_program_header" v-if="!hide_head">
        Parent / Guardian Consent
        <Switch :checked="is_need" @click.native="is_show_alert_modal = true;" /> 
        <i @click="close()"><svg-icon name="close" /></i>
    </header>

    <div class="edit-scroll-list edit-parent-box" v-if="handle_data.length > 0">
        <div class="edit_program_body">
            <div class="box question-templeat">
                <!-- Introduction -->
                <div class="line line-margin" v-if="hide_head">
                    <div class="name">Parent / Guardian Consent</div>   
                    <Switch :checked="is_need" @click.native="toggle" /> 
                </div>



                <template v-if="(hide_head && is_need) || !hide_head">

                    <div :class="['line',!handle_data[ind.introduction.i].is_switch && 'line-margin']">
                        <div class="name">{{handle_data[ind.introduction.i].name}}</div>   
                        <Switch :checked="handle_data[ind.introduction.i].is_switch" @click.native="handle_data[ind.introduction.i].is_switch = !handle_data[ind.introduction.i].is_switch" />
                    </div>

                    <Field v-if="handle_data[ind.introduction.i].is_switch" :type="handle_data[ind.introduction.i].question[ind.introduction.ii].client_view.client_type" 
                        :k="handle_data[ind.introduction.i].question[ind.introduction.ii].label" 
                        :placeholder="handle_data[ind.introduction.i].question[ind.introduction.ii].client_view.plac" 
                        @update="update"  
                        :had_value="handle_data[ind.introduction.i].question[ind.introduction.ii].client_view.val" />
                    <div class="hr" style="margin: 16px 0; height: 0px; overflow: hidden; border-top: 1px solid var(--border);"></div>
                    <div class="desc">Please indicate which of the following parent / guardian information you'd like to include on your application for applicants under 18.</div>
                    
                    <!-- All -->
                    <div class="edit-item" v-for="(v, k) in handle_data.filter(e=>{return e.tag !=='for_confirm' && e.tag !=='for_introduct' && e.tag !=='for_url' })" :key="k">
                        <div class="line">
                            <div class="name">{{ v.name }}<div class="red" v-if="v.is_required">*</div></div>
                            <!-- <Switch v-if="v.require_configurable" :checked="v.is_switch" @click.native="v.is_switch = v.is_switch ? false : true" />
                            <span v-else style="font-size: 14px; color: var(--black-50);">Default</span> -->
                            <div class="desc" style="flex: none;" v-if="v.setting_number === 1">Default</div>
                            <div class="handle_req" v-else>
                                <div class="req-box" v-if="v.setting_number===3 && v.is_switch" @click=" v.is_required = !v.is_required" >
                                    <Checkbox :checked="v.is_required" />
                                    Required
                                </div>
                                
                                <Switch :checked="v.is_switch" @click.native="hanleAllQus(v)" />
                            </div>
                        </div>
                    </div>

                    <div class="hr" style="margin: 16px 0; height: 0px; overflow: hidden; border-top: 1px solid var(--border);"></div>

                    <div class="url-box">
                        <div class="url-box-content">
                            <div class="title">Parent & guardian disclaimer<span class="red">*</span></div>
                            <Field :type="'text'" :k="'disclaimer_url'" :placeholder="'https://www.website.com'" @update="update" :had_value="temp_data.disclaimer_url"/>
                            <div class="err-msg-box" v-if="err_mes.disclaimer_url">
                                <p class="err-msg" v-html="err_mes.disclaimer_url"></p>
                                <i><svg-icon name="alert" class="icon-left" /></i>
                            </div>
                        </div>
                        <div class="url-box-content">
                            <div class="title">Parent & guardian terms link<span class="red">*</span></div>
                            <Field :type="'text'" :k="'policy_url'" :placeholder="'https://www.website.com'" @update="update" :had_value="temp_data.policy_url"/>
                            <div class="err-msg-box" v-if="err_mes.policy_url">
                                <p class="err-msg" v-html="err_mes.policy_url"></p>
                                <i><svg-icon name="alert" class="icon-left" /></i>
                            </div>
                        </div>
                    </div>


                </template>
            </div>
        </div>
    </div>
    
    <!-- save -->
    <div class="save-btn-box" v-if="!hide_head">
        <Button class="save-btn" size="40" color="dark-blue" :border_r="6" @click="save()" :is_disabled="disabled_save">
            Save
        </Button>
    </div>

    <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
        <div class="box">
            <header class="delete-header">Remove parent / guardian consent from application?</header>
            <p>Applicants under 18 will no longer be able to view any questions that fall under this section. To make visible again, click + SECTION or update your Application Settings.</p>
            <div class="btns">
                <Button type="button" :border_r="6" color="white" size="32" @click.native="is_show_alert_modal = false;">No</Button>
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click.native="is_show_alert_modal = false; $emit('hide'); close();">Confirm</Button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Switch from '@/components/ui/Switch.vue';
import Field from '@/components/ui/Field.vue';
import { getIndex, handleParentUrl  } from '@/utils/ProgramsData.js';
import Checkbox from '@/components/ui/Checkbox.vue';

export default {
    name: 'ProgramForm-pae',
    emits: ['close','save','hide'],

    data() {
        return {
            handle_data:[],
            temp_data:{
                parent_guardian_introduction:'',
                disclaimer_url:'',
                policy_url:''
            },
            err_mes:{
                disclaimer_url:'',
                policy_url:''
            },
            //data_index
            ind:{
                introduction:{i:0,ii:0},
                disclaimer_url:{i:0,ii:0},
                policy_url:{i:0,ii:0},
            },
            is_show_alert_modal:false,
        }
    },

    props: {
        hide_head: {
            type: Boolean,
            default: false,
        },

        is_need: {
            type: Boolean,
            default: true,
        },

        data: {
            type: Array,
            default: []
        },

        is_edit: {
            type: Boolean,
            default: false,
        },

        pro_title:{
            type: String,
            default: '',
        },
    },

    computed: {
        disabled_save(){
            return this.err_mes.disclaimer_url || this.err_mes.policy_url || !this.temp_data.disclaimer_url || !this.temp_data.policy_url;
        },
        brand_name() {
            return this.$store.state.user_data && this.$store.state.user_data.merchant_account && this.$store.state.user_data.merchant_account.merchant_display_name;
        },
    },

    components: {
        Scrollbar,
        Button,
        Modal,
        Switch,
        Field,
        Checkbox,
    },

    methods: {
        toggle() {
            if (this.is_need) {
                this.is_show_alert_modal = true;
            } else {
                this.$emit('hide');
            }

        },

        hanleAllQus(v){
            v.is_switch = !v.is_switch;  
            v.is_required = !v.is_switch? false: v.is_required;
            if(!v.is_switch){
                v.question.forEach(e => {
                    e.client_view.show=false;
                    e.client_view.is_required=false;
                });
            }
        },

        isValidUrl(string) {
            // try {
            //     new URL(string);
            //     return true;
            // } catch (err) {
            //     return false;
            // }
            const url_pattern = /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
            return url_pattern.test(string);
        },

        update(obj){
            Object.keys(this.temp_data).forEach(key => {
                if (key === obj.key) {
                    if (key === obj.key) this.temp_data[key]= obj.val;
                }
            });

            if (obj.key==='disclaimer_url' || obj.key==='policy_url') {
                this.err_mes[obj.key] ='';

                if (obj.val && !this.isValidUrl(obj.val)) {
                    this.err_mes[obj.key] = `The url format is incorrect.`;
                }
            }

            this.$emit('update', this.save(true));
        },

        save(is_return = false){
            this.setDate();

            if (is_return) {
                return this.handle_data;
            } else {
                this.$emit('save',{data:this.handle_data,type:'parent_guardian_consent'});
            } 
            
        },

        close(){
            this.$emit('close');
        },
        
        setDate() {
            this.handle_data[this.ind.introduction.i].question[this.ind.introduction.ii].client_view.val=this.temp_data.parent_guardian_introduction?this.temp_data.parent_guardian_introduction:this.handle_data[this.ind.introduction.i].question[this.ind.introduction.ii].client_view.plac;
            this.handle_data[this.ind.disclaimer_url.i].question[this.ind.disclaimer_url.ii].client_view.val=this.temp_data.disclaimer_url;
            this.handle_data[this.ind.policy_url.i].question[this.ind.policy_url.ii].client_view.val=this.temp_data.policy_url;

            handleParentUrl(this.handle_data,this.brand_name,this.pro_title);
        }
    },


    mounted() {
        if(this.data.length>0){
            this.ind = {
                introduction:getIndex(this.data,'parent_guardian_introduction','parent_guardian_introduction'),
                disclaimer_url:getIndex(this.data,'parent_guardian_read_acknowledge_disclaimer_url','parent_guardian_read_acknowledge_disclaimer_url'),
                policy_url:getIndex(this.data,'parent_guardian_read_and_acknowledge_terms_conditions_and_privacy_policy_url','parent_guardian_read_and_acknowledge_terms_conditions_and_privacy_policy_url')
            };
            this.handle_data = JSON.parse(JSON.stringify(this.data));//make sure the data will change
            this.temp_data.parent_guardian_introduction=this.handle_data[this.ind.introduction.i].question[this.ind.introduction.ii].client_view.val;
            this.temp_data.disclaimer_url=this.handle_data[this.ind.disclaimer_url.i].question[this.ind.disclaimer_url.ii].client_view.val;
            this.temp_data.policy_url=this.handle_data[this.ind.policy_url.i].question[this.ind.policy_url.ii].client_view.val;
        }
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.edit_parent_header {
    @include flexCenter();
    justify-content: space-between;

    .ui-switch{
        margin-right: 40px;
    }
}

.edit-parent-box {

    .handle_req{
        font: var(--font-med-12);
        @include flexCenter();

        .req-box{
            @include flexCenter();
            margin-right: 8px;
            cursor: pointer;
        }
        .ui-checkbox{
            margin:unset;
            
        }
    }
    
    .line{
        @include flexCenter();
        justify-content: space-between;
        width: 100%;

        &.line-margin{
            margin-bottom: 16px;
        }
    }

    .name {
        font: var(--font-med-16);
        @include flexCenter();
        flex: 1;
    }

    .desc{
        margin-top: 8px;
    }

    .url-box{
        padding: 16px 0;

        .url-box-content{
            margin-top: 8px;

            &:first-child{
                margin-top: 0;
            }

            .title{
                font:var(--font-med-14);
            }

            .ui-input{
                margin: 4px 0 0 0;
            }
        }

        .err-msg-box{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color:var(--alert);

            i{
                width: 14px;
                height: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
            }

            svg{
                width: 10.5px;
                height: 10.5px;
                fill:var(--alert);
            }
        }
    }

    
}


.add-creator-modal .alert-modal header {
    padding: 0;
    height: auto;
    text-align: left;
    border: none;
}
</style>